export const SET_FULFILMENT = 'CHECKOUT_SET_FULFILMENT';
export const SET_SUBMITTING = 'CHECKOUT_SET_SUBMITTING';
export const SET_SUBMISSION_ERROR = 'CHECKOUT_SET_SUBMISSION_ERROR';
export const START_ATTEMPT = 'CHECKOUT_START_ATTEMPT';
export const SET_PLACED_ORDER = 'CHECKOUT_SET_PLACED_ORDER';
export const CHANGE_SCHEDULED_ORDER = 'CHECKOUT_CHANGE_SCHEDULED_ORDER';

export const FULFILMENT = Object.freeze({
  DELIVERY: 'DELIVERY',
  COLLECTION: 'COLLECTION',
});

export const AWAITING_PAYMENT = 'AWAITING_PAYMENT';
export const PAY_LATER = 'PAY_LATER';

export const FORM = 'checkout';
